import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
// import { Location } from 'history';
import { isString, assert, isArray, isFunction } from '@dateam/ark';
var RouteData = /*#__PURE__*/function () {
  function RouteData(options) {
    _classCallCheck(this, RouteData);
    this.key = void 0;
    this.path = void 0;
    this.component = void 0;
    this.guards = [];
    this.bypassGlobal = false;
    this.exact = void 0;
    this.strict = void 0;
    // location?: Location;
    this.redirect = void 0;
    this.layout = void 0;
    this.layoutData = void 0;
    this.metadata = void 0;
    var key = options.key,
      path = options.path,
      component = options.component,
      exact = options.exact,
      strict = options.strict,
      redirect = options.redirect,
      layoutData = options.layoutData,
      metadata = options.metadata;
    assert(isString(key) && key.trim().length > 0, 'route key is not valid');
    this.key = key;
    this.path = path;
    this.component = component;
    this.exact = exact;
    this.strict = strict;
    // this.location = location;
    this.redirect = redirect;
    this.layoutData = layoutData;
    this.metadata = metadata;
  }
  return _createClass(RouteData, [{
    key: "addGuards",
    value: function addGuards(guards, bypassGlobal) {
      var _this$guards;
      if (bypassGlobal === true) this.bypassGlobal = true;
      assert(isArray(guards) && !guards.some(function (guard) {
        return !isFunction(guard);
      }), 'guards are not valid');
      (_this$guards = this.guards).push.apply(_this$guards, _toConsumableArray(guards));
      return this;
    }
  }, {
    key: "applyGuards",
    value: function applyGuards(guards) {
      var _this$guards2;
      if (this.bypassGlobal === true) return this;
      assert(isArray(guards) && !guards.some(function (guard) {
        return !isFunction(guard);
      }), 'guards are not valid');
      (_this$guards2 = this.guards).unshift.apply(_this$guards2, _toConsumableArray(guards));
      return this;
    }
  }]);
}();
export { RouteData as default };